var toString = require('../to-string');

var lowerCase = function lowerCase(str) {
  return toString(str).toLowerCase();
};

module.exports = lowerCase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/string/lower-case.js
// module id = 158
// module chunks = 0 1 2